module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M32 2c0-1.106-.894-2-2-2H2C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h28c1.106 0 2-.894 2-2V2zm-8.494 14.348l-1.434 1.368c-.394.378-.936.378-1.332 0L18 15.032V23c0 .552-.646 1-1.2 1h-2c-.552 0-.8-.448-.8-1v-8.022l-2.938 2.682c-.394.378-1.086.378-1.48 0l-1.458-1.368a.93.93 0 0 1-.012-1.366l6.954-6.644a1.05 1.05 0 0 1 1.432 0l7.012 6.7c.392.378.39.99-.004 1.366z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/up-square-4.js
// module id = 1480
// module chunks = 14